const REPUBLICAN = '#d74947';
const DEMOCRAT = '#1775b0';
const LIBERTARIAN = '#dcb732';
const NEUTRAL = '#d1d1d1';
const TIE = '#999999';

export { DEMOCRAT, LIBERTARIAN, NEUTRAL, REPUBLICAN, TIE };
